export const IconSparkle = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"/>
    <path d="M19 3.5l.6 1.7L21.3 6l-1.7.6-.6 1.7-.6-1.7L16.7 6l1.7-.6.6-1.7z"/>
  </svg>
)

export const IconHome = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M4 11.5L12 4l8 7.5"/>
    <path d="M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9"/>
  </svg>
)

export const IconWrite = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M4 20l1-4.5L15.8 5.2a1.7 1.7 0 0 1 2.4 0l.6.6a1.7 1.7 0 0 1 0 2.4L8.5 19 4 20z"/>
  </svg>
)

export const IconPin = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M12 21s-6.5-5.6-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.4-6.5 11-6.5 11z"/>
    <circle cx="12" cy="10" r="2.2"/>
  </svg>
)

export const IconChart = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M4 20V10M11 20V4M18 20v-7"/>
    <path d="M2.5 20h19"/>
  </svg>
)

export const IconGear = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="3"/>
    <path d="M12 3v2.2M12 18.8V21M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M3 12h2.2M18.8 12H21M4.9 19.1l1.6-1.6M17.5 6.5l1.6-1.6"/>
  </svg>
)

export const IconAlert = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M12 4.2l9 15.6H3l9-15.6z"/>
    <path d="M12 10.3v4M12 17.2h.01"/>
  </svg>
)

export const IconMessage = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4.5 3.5V17H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"/>
  </svg>
)

export const IconTag = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M12.6 3.4L20.6 11.4a2 2 0 0 1 0 2.8l-6.4 6.4a2 2 0 0 1-2.8 0L3.4 12.6V4a.6.6 0 0 1 .6-.6h8.6z"/>
    <circle cx="8" cy="8" r="1.4"/>
  </svg>
)

export const IconGlobe = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9"/>
    <path d="M3 12h18M12 3c2.6 2.4 4 5.6 4 9s-1.4 6.6-4 9c-2.6-2.4-4-5.6-4-9s1.4-6.6 4-9z"/>
  </svg>
)

export const IconCart = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M6 8h13l-1.5 9.2a1 1 0 0 1-1 .8H8.4a1 1 0 0 1-1-.8L6 8z"/>
    <path d="M6 8L4.5 4H2.5"/>
    <circle cx="9.5" cy="21" r="1.1"/>
    <circle cx="16.5" cy="21" r="1.1"/>
  </svg>
)

export const IconUser = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <circle cx="12" cy="8.2" r="3.4"/>
    <path d="M4.5 20.5c1.4-4 4-5.8 7.5-5.8s6.1 1.8 7.5 5.8"/>
  </svg>
)

export const IconCard = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <rect x="2.5" y="5.5" width="19" height="13" rx="1.6"/>
    <path d="M2.5 10h19"/>
    <path d="M5.5 14.5h4"/>
  </svg>
)

export const IconCheck = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9"/>
    <path d="M8 12.3l2.6 2.6L16.3 9"/>
  </svg>
)

export const IconFlame = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M12 21c-4 0-6.5-2.6-6.5-6 0-3 2-4.6 2.6-7.4C8.9 5.5 10 4 12 3c-.6 2.4.3 3.7 1.6 5C15 9.4 16 10.8 16 13c0 .8-.2 1.5-.5 2.1 1-.7 1.7-1.9 1.7-3.4 2 1.7 2.8 3.7 2.8 5.3 0 2.5-3 4-8 4z"/>
  </svg>
)

export const IconFile = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M7 3h7l4 4v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/>
    <path d="M14 3v4h4"/>
    <path d="M9 13h6M9 16.5h6"/>
  </svg>
)

export const IconList = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <path d="M8 6h13M8 12h13M8 18h13"/>
    <circle cx="3.5" cy="6" r="1"/>
    <circle cx="3.5" cy="12" r="1"/>
    <circle cx="3.5" cy="18" r="1"/>
  </svg>
)

export const IconCalendar = () => (
  <svg className="ic-svg" viewBox="0 0 24 24">
    <rect x="3" y="5" width="18" height="16" rx="2"/>
    <path d="M3 10h18M8 3v4M16 3v4"/>
  </svg>
)
